module.exports = __webpack_public_path__ + "img/1_017.298c7ce5.jpg";